import React from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutUs from './components/AboutUs';
import Products from './components/Products';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';  
import 'bootstrap/dist/js/bootstrap.bundle.min';
function App() {
  return (
    <div>
      <Navbar />
      <HeroSection />
      <AboutUs />
      <Products />
      <ContactUs />
      <Footer />
    </div>
  );
}

export default App;
